import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ServerTestSection = () => {
  const { t } = useLanguage();

  return (
    <div className="text-center pb-2 relative z-10 flex flex-col items-center">

      <h1
        className="uppercase text-center mx-auto mb-3 sm:mb-4"
        style={{
          fontFamily: "var(--font-display, 'Bebas Neue', sans-serif)",
          fontWeight: 700,
          letterSpacing: '0.025em',
          lineHeight: 0.86,
          fontSize: 'clamp(4.6rem, 15.5vw, 12.5rem)',
          color: '#ffffff',
          filter: 'drop-shadow(0 0 35px rgba(255, 255, 255, 0.15))',
          maxWidth: '1100px',
          whiteSpace: 'nowrap',
          userSelect: 'text',
          WebkitUserSelect: 'text'
        }}
      >
        STORMBLACK
      </h1>

      <p
        className="px-2 sm:px-4"
        style={{
          fontSize: 'clamp(0.95rem, 2.2vw, 1.25rem)',
          color: '#f5f5f7',
          maxWidth: '760px',
          margin: '0 auto 24px auto',
          fontWeight: 400,
          lineHeight: 1.55
        }}
      >
        {t('serverTestDescription') ||
          'Подключитесь к одному из серверов ниже, чтобы начать комплексное тестирование безопасности и обнаружить уязвимости'}
      </p>
    </div>
  );
};

export default ServerTestSection;